module.exports = __webpack_public_path__ + "static/media/dashboardgreen-new.e989c65d.svg";